import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const Sifu = () => {
  const { lang } = useLanguage();
  const t = useT(lang);

  return (
    <div className="py-24 md:py-32">
      <div className="container-wc">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="aspect-[3/4] overflow-hidden border border-goldSoft relative bg-gradient-to-br from-[#1a1a1a] via-[#0d0d0d] to-black">
              {/* Decorative Chinese character background */}
              <span className="absolute -right-8 -top-8 font-cn text-gold text-[240px] leading-none opacity-10 select-none pointer-events-none">師</span>
              {/* Radial gold glow behind figure */}
              <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 60%, rgba(212,175,55,0.15) 0%, transparent 55%)" }} />
              <img
                src="https://customer-assets-7cd3h4nn.emergentagent.net/job_martial-arts-refresh/artifacts/n6u5pokg_Sifu_Nikos_Agathopoulos.png"
                alt="Sifu Nikos Agathopoulos"
                className="relative w-full h-full object-contain z-10"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black via-black/60 to-transparent z-20">
                <span className="font-cn text-gold text-3xl">師傅</span>
                <span className="block text-xs text-dim tracking-[0.3em] uppercase mt-1">Sifu · Master</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 fade-up">
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-gold" />
              <span className="eyebrow">Sifu</span>
            </div>
            <h1 className="h-display text-5xl md:text-6xl mb-6">{t.sifu.title}</h1>
            <p className="text-gold text-xl font-serif italic mb-10">{t.sifu.subtitle}</p>

            <div className="space-y-6 text-lg leading-relaxed text-[#E8E8E0]">
              <p>{t.sifu.p1}</p>
              <p>{t.sifu.p2}</p>
              <p>{t.sifu.p3}</p>
            </div>

            <div className="mt-12 p-8 bg-surface border-l-2 border-gold">
              <h3 className="font-serif text-2xl mb-3">{t.sifu.role_title}</h3>
              <p className="text-dim leading-relaxed">{t.sifu.role_text}</p>
            </div>

            <div className="mt-12">
              <Link to="/contact" data-testid="sifu-cta" className="btn-primary">
                {t.hero.cta_primary} <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sifu;
